export default "__VITE_ASSET__CBSXwz14__"